import AppConfig from "../app-config";
const useConfig = () => {
    const config = AppConfig.getConfig();
    return Object.assign(Object.assign({}, config), { toAbsoluteUrl: (pathname) => config.publicUrl + pathname, getPostViewUrl: (postId) => config.urls.postView.replace(/\{post_id\}/, postId.toString()) });
};
export default useConfig;
